import CtaBox from './cta-box'

export default CtaBox
